import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Anchor, Text, Title } from "@mantine/core";

import { Card } from "@prostocheck/ui";

export const RegisterNotFound = () => {
  const { t } = useTranslation();

  return (
    <Card className="mx-auto max-w-md text-center">
      <Title order={1} size="h4">
        {t("register.notFound.title")}
      </Title>
      <Text size="sm" c="dimmed" mt="xs">
        {t("register.notFound.description")}
      </Text>
      <Anchor
        component={Link}
        to="/registers"
        size="sm"
        fw={500}
        display="inline-block"
        mt="md"
      >
        {t("register.notFound.back")}
      </Anchor>
    </Card>
  );
};
